import React from 'react';

// Interface for CommonHeading props
interface CommonHeadingProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

// Common Heading Component
const CommonHeading: React.FC<CommonHeadingProps> = ({ title, subtitle, className = '' }) => {
  return (
    <div className={`text-left mb-6 ${className}`}>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800">{title}</h2>
      {subtitle && <p className="text-lg text-gray-600 mt-2">{subtitle}</p>}
    </div>
  );
};

export default CommonHeading;